import { displayDollar, displayPercentage} from "utilities/tableUtility";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import K from "utilities/constants";
import { convertIntoDashUSFormat } from "utilities/dateUtility";
import {checkNullPlaceHolder} from "../../../../../utilities/generalUtility";

export const Columns = [
  {
    ...DefaultColumnOptions.Id,
    sortable: true
  },
  {
    headerName: "Candidate",
    field: "candidateName",
    sortable: true,
    tooltipField: "candidateName",
  },
  {
    headerName: "Candidate Type",
    field: "candidateType",
    sortable: true,
    cellRenderer: (params) => K.CandidateType[params.data?.candidateJobEntry?.candidateType] || K.NullPlaceholder,
  },
  {
    headerName: "Job Title",
    field: "jobTitle",
    sortable: true,
  },
  {
    headerName: "Billing Type",
    field: "billingTypeName",
    sortable: true,
  },
  {
    headerName: "Job Location",
    field: "jobLocation",
    sortable: true,
    cellRenderer: (params) => checkNullPlaceHolder(params.data.jobSource?.jobLocation?.name),
  },
  {
    headerName: "Job Department",
    field: "jobDepartment",
    sortable: true,
    valueGetter: ({ data }) =>
      checkNullPlaceHolder(data.jobSource?.jobDepartment?.name),
  },
  {
    headerName: "Job Group",
    field: "jobGroup",
    sortable: true,
    valueGetter: ({ data }) =>
      checkNullPlaceHolder(data.jobSource?.jobGroup?.name),
  },
  {
    headerName: "Original Price",
    field: "amount",
    sortable: true,
    cellRenderer: (params) => displayDollar(params.value ?? 0.0),
  },
  {
    headerName: "Discount %",
    field: "discountPercentage",
    sortable: true,
    cellRenderer: (params) => displayPercentage(params.value ?? 0.0),
  },
  {
    headerName: "Price",
    field: "dublicateAmount",
    sortable: true,
    cellRenderer: (params) => displayDollar(params.value ?? 0.0),
  },
  {
    headerName: "Start Date",
    field: "startDate",
    sortable: true,
    sort: "asc",
    cellRenderer: (params) => convertIntoDashUSFormat(params.data.candidateJobEntry?.startDate, false),
  },
  {
    headerName: "Source",
    field: "sourceName",
    sortable: true,
    valueGetter: ({ data }) =>
      checkNullPlaceHolder(data.candidateJobEntry?.source?.name),
  },
  {
    headerName: "Credit Reason",
    field: "issueCreditReason",
    sortable: true,
    cellRenderer: (params) => checkNullPlaceHolder(params?.value),
  },
];
